import React from 'react';
import { FormattedMessage } from 'react-intl';

function PlaylistTabBar({ tabs, activeTab, onTabChange }) {
  return (
    <div className="d-flex border-bottom playlist-tabs-bar">
      {Object.entries(tabs).map(([key, label], idx) => (
        <div
          key={key}
          className={[
            "flex-fill d-flex align-items-center justify-content-center label-bold playlist-tab",
            activeTab === key && "active",
            idx < Object.keys(tabs).length - 1 && "playlist-tab-border",
            idx === 0 && "playlist-tab-radius"
          ].filter(Boolean).join(' ')}
          onClick={() => onTabChange(key)}
        >
          <FormattedMessage id={label} defaultMessage={label} />
        </div>
      ))}
    </div>
  );
}

export default PlaylistTabBar;
